import getFormById from './getFormById'
import saveForm from './saveForm'
import saveSection from './saveSection'
import generateForm from './generateForm'

export const getFormByIdPromise = getFormById
export const saveFormPromise = saveForm
export const saveSectionPromise = saveSection
export const generateFormPromise = generateForm
